import { NgModule } from '@angular/core';

import { ErrorRoutingModule } from './error.routing';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [UnauthorizedComponent, NotFoundComponent],
  imports: [SharedModule, ErrorRoutingModule]
})
export class ErrorModule {}
